import { render } from "./Woo.vue?vue&type=template&id=1c734964&scoped=true"
import script from "./Woo.vue?vue&type=script&lang=js"
export * from "./Woo.vue?vue&type=script&lang=js"

import "./Woo.vue?vue&type=style&index=0&id=1c734964&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/public_html/wp-content/plugins/woo-portal-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c734964"]])

export default __exports__